import Component from "@lib/Component.js";

export default class Nav extends Component {
  init() {
    super.init();

    this.btburger = document.querySelector(".nav-tools-burger");
    this.tools = document.querySelector(".nav-tools-tools");

    this.addListeners();
  }

  addListeners() {
    for (let i = 0; i < this.refs.navItem.length; i++) {
      const element = this.refs.navItem[i];
      element.addEventListener("mouseenter", this);
      element.addEventListener("mouseleave", this);
      element.addEventListener("touchstart", this);
    }

    this.refs.navContainer.addEventListener("mouseleave", this);

    this.btburger.addEventListener("click", this);
    this.refs.btback.addEventListener("click", this);
  }

  handleEvent(event) {
    if (event.currentTarget.classList.contains("nav-item")) {
      if (event.type === "mouseenter") this.navItemMouseenter(event);
      if (event.type === "touchstart") this.navItemTouchstart(event);
    }

    if (event.currentTarget === this.refs.navContainer) {
      if (window.innerWidth <= 768) return;
      if (event.type === "mouseleave") {
        this.el.classList.remove("open");
        for (let i = 0; i < this.refs.navItem.length; i++) {
          const element = this.refs.navItem[i];
          element.classList.remove("selected");
        }
      }
    }

    if (event.currentTarget === this.btburger && event.type === "click") {
      if (this.el.classList.contains("open")) {
        this.closeMobile();
      } else {
        this.openMobile();
      }
    }

    if (event.currentTarget === this.refs.btback && event.type === "click") {
      this.refs.navContainer.classList.remove("show");
      this.tools.classList.add("show");
    }
  }

  navItemTouchstart(event) {
    if (event.currentTarget.dataset.canopen === "true") {
      this.refs.navContainer.classList.add("eventnone");
      this.refs.navContainer.classList.add("show");
      setTimeout(() => {
        this.refs.navContainer.classList.remove("eventnone");
      }, 600);
      this.tools.classList.remove("show");
      this.select(event.currentTarget);
    }
  }

  navItemMouseenter(event) {
    if (window.innerWidth <= 768) return;
    for (let i = 0; i < this.refs.navItem.length; i++) {
      const element = this.refs.navItem[i];
      element.classList.remove("selected");
    }

    if (event.currentTarget.dataset.canopen === "true") {
      this.select(event.currentTarget);
    } else {
      this.el.classList.remove("open");
    }
  }

  select(target) {
    target.classList.add("selected");
    this.el.classList.add("open");

    for (let i = 0; i < this.refs.navContent.length; i++) {
      const element = this.refs.navContent[i];
      element.classList.remove("selected");
      if (element.classList.contains(target.dataset.alias)) {
        element.classList.add("selected");
      }
    }
  }

  openMobile() {
    this.btburger.classList.add("open");
    this.el.classList.add("open");
    this.tools.classList.add("show");
    document.body.classList.add("noscroll");
  }

  closeMobile() {
    this.btburger.classList.remove("open");
    this.el.classList.remove("open");
    this.tools.classList.remove("show");
    document.body.classList.remove("noscroll");
    this.refs.navContainer.classList.remove("show");
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Nav.js